// Vite inlines `import.meta.env.VITE_*` at BUILD time into a publicly readable
// bundle, so nothing secret belongs here. Each variable also needs a CI scope for
// dev / staging / production / review, or the build silently ships undefined.
//
// These were `process.env.*` under Next, injected by next.config.js.
export const env = {
  ptdApiBase: import.meta.env.VITE_PTD_API_BASE ?? '',
  googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY ?? '',
  adminLoginUrl: import.meta.env.VITE_ADMIN_LOGIN_URL ?? '',
  // Undefined rather than '' so GoogleMap takes its no-mapId branch and falls back to `styles`; an empty string reads as a real map id and yields a blank map.
  googleMapId: import.meta.env.VITE_GOOGLE_MAP_ID || undefined,
  // Set only at the review/* CI scope, so no staging or production build can carry it; empty means "read the host".
  reviewTenant: import.meta.env.VITE_REVIEW_TENANT || undefined
}
